// TJBA 問い合わせ・資料請求フォームの送信先 (GAS WebApp)
// scriptId: 1Aj2PJI62fKh7eRzjRgBqSt6HZ0_I4Ag_9pvm2-ruHNaKe2usRrGLx926 (owner: y.ishii@thespectre.jp)
// 匿名アクセス可の稼働デプロイ (v1)。HEADデプロイのURLはGoogleログイン必須のため使用しない。
// GASはCORSプリフライトに応答できないため、Content-Type は text/plain でJSON文字列を送る。
export const CONTACT_ENDPOINT =
  'https://script.google.com/macros/s/AKfycbzVHmPZjel12QonGpVipBYlC0qHjTNfKZqb43GwMun4sOzxxXTKkv0FIBxws_dMsrhY/exec';

export const CONTACT_HEADERS = { 'Content-Type': 'text/plain;charset=utf-8' };

export type ContactLang = 'ja' | 'en';

// LanguageContext と同一規則: /en 配下なら 'en'（URLが言語の唯一のソース）
export function detectContactLang(pathname: string = window.location.pathname): ContactLang {
  return pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'ja';
}

// 全フォーム共通の送信ヘルパー。lang / formType / _hp / source を必ず付与する。
export async function submitContact(
  formType: string,
  data: object,
): Promise<Response> {
  return fetch(CONTACT_ENDPOINT, {
    method: 'POST',
    headers: CONTACT_HEADERS,
    body: JSON.stringify({
      ...data,
      formType,
      lang: detectContactLang(),
      _hp: '',
      source: window.location.href,
    }),
  });
}
